import { render } from "./ProductsList.vue?vue&type=template&id=17792990&ts=true"
import script from "./ProductsList.vue?vue&type=script&lang=ts"
export * from "./ProductsList.vue?vue&type=script&lang=ts"

import "./ProductsList.vue?vue&type=style&index=0&id=17792990&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__